import React from 'react'
// import { TransitionGroup, CSSTransition } from "react-transition-group";

import project from '../../project'
import Data from './Data'
import BreachCodes from './BreachCodes'
import { Tracking } from '../../../NodeModules/nnd-track-page'
import { Tracking219 } from './Tracking'
import { ajaxSetup, getJSON } from 'jquery'
import axios from 'axios';

// import ShowMoreText from 'react-show-more-text';

import "../assets/styles/home.scss"

let environment = 'PROD' // PROD or DEV
const apiUrl = (environment === 'PROD') ? 'https://us-central1-ncau-editorial-dapi-prod.cloudfunctions.net/app/api/v1' : 'https://us-central1-ncau-editorial-dapi-dev.cloudfunctions.net/app/api/v1'
const apiURL_storage = (environment === 'PROD') ? 'https://storage.googleapis.com/dapi-prod-data/AFLrich100_2021.json' : 'https://storage.googleapis.com/dapi-dev-data/AFLrich100_2021.json'
const apiCollection = 'AFLrich100_2021'

ajaxSetup({ cache: true })

/* LOAD READER RANKING */
let sortByKey = (array, key, ascdesc) => {
  return array.sort((a, b) => {
    let x = (ascdesc === 'asc') ? b[key] : a[key]
    let y = (ascdesc === 'asc') ? a[key] : b[key]
    return -((x < y) ? -1 : ((x > y) ? 1 : 0))
  })
}

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.scrollDiv = React.createRef()
    this.state = {
      view: 'expert',
      firstInteraction: false,
      votingDisabled: false,
      data: undefined, //this.loadData()
      breach: null,
      SubscriptionUrl: '',
      siteDomain: '',
      siteCode: '',
      isMobApp: false
    }

    this.siteCode = this.siteCode.bind(this)
    this.checkBreach = this.checkBreach.bind(this)
    this.loadData = this.loadData.bind(this)
    this.visChange = this.visChange.bind(this)

    const thisState = this

    this.addBodyEvents()

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('mouseenter', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })
    
  }

  componentDidMount () {
    // this.loadData()
    this.checkBreach()
  }

  visChange (isVisible) {
    // console.log('Breach is now %s', isVisible ? 'visible' : 'hidden');
    if ( isVisible && this.state.appInViewport === false) {
      this.state.appInViewport = true
      Tracking219.trackBreachImpression('app In Viewport', project.name)
    }
  }

  siteCode (siteHostname) {
    let siteCode, siteDomain
    switch (siteHostname) {
      
      case 'www.adelaidenow.com.au' :
        siteCode = 'adv'
        siteDomain = 'adelaidenow'
        break
      
      case 'www.cairnspost.com.au' :
        siteCode = 'cp'
        siteDomain = 'cairnspost'
        break
      
      case  'www.couriermail.com.au' :
        siteCode = 'cm'
        siteDomain = 'couriermail'
        break
      
      case  'www.heraldsun.com.au' :
        siteCode = 'hs'
        siteDomain = 'heraldsun'
        break
      
      case  'www.geelongadvertiser.com.au' :
        rsiteCode = 'ga'
        siteDomain = 'geelongadvertiser'
        break
      
      case  'www.goldcoastbulletin.com.au' :
        siteCode = 'gcb'
        siteDomain = 'goldcoastbulletin'
        break

      case  'www.ntnews.com.au' :
        siteCode = 'ntn'
        siteDomain = 'ntnews'
        break
      
      case  'www.thechronicle.com.au' :
        siteCode = 'twc'
        siteDomain = 'thechronicle'
        break

      case  'www.themercury.com.au' :
        siteCode = 'merc'
        siteDomain = 'themercury'
        break
      
      case  'www.townsvillebulletin.com.au' :
        siteCode = 'tb'
        siteDomain = 'townsvillebulletin'
        break
      
      case  'www.weeklytimesnow.com.au' :
        siteCode = 'wtn'
        siteDomain = 'weeklytimesnow'
        break
      
      case  'www.dailytelegraph.com.au' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break

      case 'localhost' :
        siteCode = 'dt'
        siteDomain = 'dailytelegraph'
        break
    }
    this.setState({
      siteCode: siteCode,
      siteDomain: siteDomain
    })

    return siteCode

  }

  goLogin () {
    const loginButton = document.querySelectorAll('.header_log-in, .tgc-auth-buttons_login') // Mastheads, Regionals
    loginButton[0].click()
  }

  checkBreach () {

    // check for both new and old app
    const isMobileApp = document.getElementById('screenkit--embed-container') || window.DNA_APP_ENV;

    // console.log('isMobileApp', isMobileApp);
    // console.log('window.utag_data', window.utag_data);
        
    if (isMobileApp) {
      this.state.breach = false
      this.state.isMobApp = true
      this.loadData()

    } else if (window.utag_data) {
      if( (typeof window.utag_data.net_platform !== "undefined") && (typeof window.utag_data.pc_memtype !== "undefined") ) {
          const currentDomain = window.location.hostname
          const currentUrl = window.location.href
          const netsite = this.siteCode(window.location.hostname)
          const netplatform = window.utag_data.net_platform
          const breachSourceCode = BreachCodes[netsite][netplatform]
          const subUrl = 'https://'
            + currentDomain
            + '/subscribe/news/1/'
            + '?sourceCode=' + breachSourceCode
            + '&dest=' + encodeURIComponent(currentUrl)
            + '&memtype=anonymous&mode=premium'

          this.state.SubscriptionUrl = subUrl
          this.state.breach = ( utag_data && utag_data.pc_memtype == "subscriber" ) ? false : true;
          this.loadData()

      }
      else {
          setTimeout(this.checkBreach, 250);
      }
    }
    else {
      setTimeout(this.checkBreach, 250);
    }
    
  }

  dataSlash () {
    let slashedData = this.state.rawData.slice(-20)

    // console.log('slashedData', slashedData)

    this.setState({
      data: slashedData,
      rawData: '' // hide data no longer needed
    })
    
  }

  scroll2message () {
    this.scrollDiv.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  goSubscribe () {
    window.location.replace(this.state.SubscriptionUrl);
  }

  addBodyEvents () {
    setTimeout(() => {
      let navFromTop = document.getElementsByClassName('nnd-navigation')
      let navFromTopBg = document.getElementsByClassName('nnd-navigation-bg')
      let navWidth = navFromTop[0].clientWidth
      let navTopOffset = navFromTop[0].offsetTop
      window.addEventListener('scroll', (e) => {
        this.onScrollEvent(navFromTop, navFromTopBg, navWidth, navTopOffset)
      })
    }, 1000)
  }

  onScrollEvent (navFromTop, navFromTopBg, navWidth, navTopOffset) {
    let nndContainer = document.getElementsByClassName('nnd-container')
    let lastRowContainer = document.getElementsByClassName('nnd-cont-main')[0].firstElementChild
    let totalHeight = nndContainer[0].offsetTop + nndContainer[0].clientHeight - lastRowContainer.clientHeight
    let lastContHeight = nndContainer[0].clientHeight + navFromTop[0].clientHeight - lastRowContainer.clientHeight * 2
    navFromTop[0].style.width = `${navWidth}px`
    navFromTopBg[0].style.height = `${navFromTop[0].clientHeight}px`    
    if (window.scrollY > navTopOffset) {
      // console.log('scrolled over')
      if (window.scrollY > totalHeight) {
        navFromTop[0].setAttribute('name', 'nnd-absolutefromtop')
        navFromTopBg[0].setAttribute('name', 'nnd-normal')
        navFromTop[0].style.top = `${lastContHeight}px`
      } else {
        navFromTop[0].setAttribute('name', 'nnd-fixedtotop')
        navFromTopBg[0].setAttribute('name', 'nnd-fixedtotop')
        navFromTop[0].style.top = `0px`
      }
    } else {
      // console.log('scrolled back')
      navFromTop[0].setAttribute('name', 'nnd-normal')
      navFromTopBg[0].setAttribute('name', 'nnd-normal')
      navFromTop[0].style.top = `0px`
    }
  }


  loadData () {
    
    const thisData = Data
    // const totalItems = thisData.length
    // const thisState = this

    this.setState({
      rawData: thisData
    })

    // hit storage for PROD
    
    // console.log('Get Votes Storage')
    
    axios.get(apiURL_storage)
    .then((response) => {
      this.processItems(response.data.items)
      // console.log('response.data', response.data.items);
      this.setState({
        voteData: response.data.items
      })
    })
    // .catch(err => console.error(err))
    .catch((err) => {
      console.log('err', err)
      // console.error(err)
    })
    
    
    // hit api direct fot testing/dev NOT FOR PROD
    /*
    axios.get(`${apiUrl}/vote/fetch`, {
      params: {
        // projectName: 'NrlStateOfOrigin2020G1',
        projectName: apiCollection,
        collectionId: 'vote',
        count: 301, // Optional. Set a limit on the number of items returned. Default is 20.
        offset: 0, // Optional. Start offset in the collection. Offsets start at 0. 
      }
    })
    .then((res) => {
      const { count, endOffset, items, startOffset, total } = res.data
      // console.log('Fetched votes')
      // console.log('res.data', res.data)
      // console.log('count', count)
      // console.log('endOffset', endOffset)
      // console.log('startOffset', startOffset)
      // console.log('items', items)
      // console.log('total', total)
      // setVoteData(items)
      this.setState({
        voteData: items
      })
      this.processItems(items)
      // console.log('items', items)
    })
    .catch(err => console.error(err))
    */
    
  }

  processItems (items) {
    // console.log('items', items)

    let rData = []
    const itemCount = this.state.rawData.length
    // console.log('itemCount', itemCount)

    let thisData = this.state.rawData

    // add required objects
    for (var i = 0; i < itemCount; i++) {
      rData.push( { 'id': i+1 } );
    }

    // console.log('rData', rData)

    items.forEach(function(document) {
        // console.log('document',document.category)
        const playerId = document.categoryA.split('_')[0].replace('player', '')
        const ratingCategory = document.categoryA.split('_')[1]
        const ratingTotal = document.total
        // console.log(playerId, ratingCategory, ratingTotal)

        const objIndex = rData.findIndex( x => x.id === parseInt(playerId) );
        // console.log('objIndex', objIndex, rData[objIndex])
        rData[objIndex][ratingCategory] = ratingTotal

    });

    // console.log('rData', rData)

    for (let i = 0; i < rData.length; i++) {
      let underrated = Number(rData[i]['underrated'])
      let agreed = Number(rData[i]['agree'])
      let overrated = Number(rData[i]['overrated'])
      // Add weightage to the votes as per expert ranking
      // console.log('ratingd u a o', underrated, agreed, overrated)
      // console.log('rData[i]["id"]', rData[i]["id"])

      rData[i]['reader_ranking_val'] = ((underrated - overrated) + agreed) + ((itemCount * 5) - (( rData[i]["id"] + 1) - 1) * 5)
    }

    // Sort leader ranking from 1-50 based on votes
    let readerRanking = sortByKey(rData, 'reader_ranking_val', 'desc')
    // console.log('readerRanking:', readerRanking)

    for (let l = 0; l < readerRanking.length; l++) {
      // let thisPos = parseInt(readerRanking[l]['r_id'].replace('r_', ''), 10)
      let thisPos = parseInt(readerRanking[l]['id'], 10)
      let elementPos = thisData.map(function (x) { return x.id }).indexOf(thisPos)
      // console.log('thisPos', thisPos)
      // console.log('elementPos', elementPos)

      if (elementPos > -1) {
        thisData[elementPos]['peopleid'] = (l + 1)
        thisData[elementPos]['perc']['agree'] = readerRanking[l]['agree']
        thisData[elementPos]['perc']['overrated'] = readerRanking[l]['overrated']
        thisData[elementPos]['perc']['underrated'] = readerRanking[l]['underrated']

        // agree = agree, higher = overrated, lower = underrated
        let totalVotes = (readerRanking[l]['agree'] + readerRanking[l]['overrated'] + readerRanking[l]['underrated'])
        let calUnderrated = Math.round((readerRanking[l]['underrated'] * 100) / totalVotes)
        let calOverrated = Math.round((readerRanking[l]['overrated'] * 100) / totalVotes)
        let calAgree = Math.round((readerRanking[l]['agree'] * 100) / totalVotes)

        calUnderrated = isNaN(calUnderrated) ? 0 : calUnderrated
        calOverrated = isNaN(calOverrated) ? 0 : calOverrated
        calAgree = isNaN(calAgree) ? 0 : calAgree

        // console.log('calAgree', calAgree)
        // console.log('calOverrated', calOverrated)
        // console.log('calUnderrated', calUnderrated)

        if ( (calUnderrated + calOverrated + calUnderrated) !== 100 && (calUnderrated + calOverrated + calUnderrated) !== 0 ) {
          calAgree = (100 - calUnderrated - calOverrated)
        }

        // add calculated % to data
        thisData[elementPos]['perc']['agreePC'] = calAgree
        thisData[elementPos]['perc']['overratedPC'] = calOverrated
        thisData[elementPos]['perc']['underratedPC'] = calUnderrated

      }

      if ((readerRanking.length - 1) === l) {
        /*this.setState({
          data: thisData
        })*/

        this.setState({
          data: thisData
        }, function () {
          if ( this.state.breach === true ) {
            this.dataSlash()
          }
        });

      }
    }
  }

  setClassName (e, tabName) {
    if (tabName !== this.state.view) {
      document.getElementsByClassName(`nnd-active-${this.state.view}`)[0].classList.remove(`nnd-active-${this.state.view}`)
      e.target.classList.add(`nnd-active-${tabName}`)
      const grid = document.querySelector('.nnd-cont-main')
      grid.classList.toggle('nnd-hide')
      setTimeout(() => {
        this.state.view = tabName
        grid.setAttribute('name', `nnd-${tabName}`)
        let ratingReaders = grid.querySelectorAll('.nnd-col-rating')
        ratingReaders.forEach((e) => {
          e.classList.toggle('nnd-active-people')
        })
        setTimeout(() => {
          grid.classList.toggle('nnd-hide')
          Tracking.trackPageImpression(tabName, project.name)
        }, 200)
      }, 200)
    }
  }

  addVote (e, id, voteType) {
    let thisIndex = ( this.state.breach === false ) ? (id - 1) : (id - 1 - 80)
    let isPeople = document.querySelector(`[name="nnd-people"]`)
    // console.log('isPeople', isPeople)
    if (!this.state.data[thisIndex].status && !isPeople  && !this.state.votingDisabled) {

      e.persist();
      // e.target.classList.add(`nnd-voting`)
      // e.target.parentNode.classList.add(`nnd-voted`)

      const voteKey = 'player' + id + '_' + voteType
      // console.log('voteKey', voteKey)
      
      this.setState({
        votingDisabled: true
      })

      let voteData = this.state.voteData
      // console.log('voteData', voteData)
      // submit the vote

      // SEND VOTE
      const documentId = voteData.filter( (el) => voteKey === el.categoryA )[0].docid
      // console.log('documentId', documentId)
      
      axios.post(`${apiUrl}/vote/send`, {
        projectName: apiCollection,
        collectionId: 'vote',
        documentId: documentId
      })
      .then((res) => {
        this.processButtons(e, id, voteType)
      })
      .catch((err) => {
        // console.error(err)
        this.processButtons(e, id, voteType)
      })
    }
  }

  processButtons(e, id, voteType) {
    // console.log('e, id, voteType ',e, id, voteType)
    // e.target.classList.remove(`nnd-voting`)
    // e.target.textContent = `voted`

    const thisIndex = this.state.breach === false ? (id - 1) : (id - 1 - 80) // breach only 100 to 81
    e.target.classList.add(`nnd-active`)

    let pObj = this.state.data.find(obj => {
      return obj.id === id
    })

    // console.log("pObj.perc 1", pObj.perc);

    // adjust for this vote for posted value
    if (voteType === 'underrated') {
      pObj['perc']['underrated']++
    } else if (voteType === 'overrated') {
      pObj['perc']['overrated']++
    } else if (voteType === 'agree') {
      pObj['perc']['agree']++
    }

    // console.log("pObj.perc 2", pObj.perc);
    
    let totalVotes = (pObj.perc.agree + pObj.perc.overrated + pObj.perc.underrated)
    let calUnderrated = Math.round((pObj.perc.underrated * 100) / totalVotes)
    let calOverrated = Math.round((pObj.perc.overrated * 100) / totalVotes)
    let calAgree = Math.round((pObj.perc.agree * 100) / totalVotes)
    if ((calUnderrated + calOverrated + calUnderrated) !== 100) {
      calAgree = (100 - calUnderrated - calOverrated)
    }

    // console.log('1 thisIndex', thisIndex, this.state.data[thisIndex])

    this.state.data[thisIndex].status = voteType
    this.state.data[thisIndex].perc.underratedPC = (calUnderrated + '%')
    this.state.data[thisIndex].perc.overratedPC = (calOverrated + '%')
    this.state.data[thisIndex].perc.agreePC = (calAgree + '%')

    // console.log('2', this.state.data[thisIndex])

    let selectElement = document.querySelector(`.nnd-expert-` + id + ` .nnd-btns`)
    let btns = selectElement.querySelectorAll('a')

    btns[0].querySelector('em').innerHTML = calAgree + '%'
    btns[1].querySelector('em').innerHTML = calOverrated + '%'
    btns[2].querySelector('em').innerHTML = calUnderrated + '%'
    

    btns.forEach((but) => {
      let oldBut = but
      // console.log('oldBut', oldBut);
      let newBut = oldBut.cloneNode(true)
      oldBut.parentNode.replaceChild(newBut, oldBut)
    })

    selectElement.classList.add(`nnd-voted`)

    this.setState({
      votingDisabled: false
    })

  }

  render() {
    const mylist = (typeof this.state.data !== 'undefined') ? this.state.data.map((item) => {
      // console.log('item.imagename', item)
      if (typeof this.state.data !== 'undefined') {
        return (
         <div key={item.id} className={`nnd-row nnd-expert-${item.id} nnd-people-${item.peopleid}`}>
           <div className="nnd-col-rating"><span className="nnd-rating-expert">{ item.id }</span><span className="nnd-rating-people">{ item.peopleid }</span></div>
           <div className="nnd-col-img">
             <picture>
               <source srcSet={require(`../assets/images/${item.imagename}.jpg`)} media="(min-width: 768px)" />
               <img srcSet={require(`../assets/images/${item.imagename}.jpg`)} src={require(`../assets/images/${item.imagename}.jpg`)} />
             </picture>
           </div>
           <div className="nnd-col-text">
             <h3>{ item.name }</h3>
             <p className="nnd-club">{ item.club }</p>
             <h4 className="nnd-salary">{ item.salary }</h4>
             <p> { item.bio } </p>
             <p className="nnd-expert-voteText">What do you think of the ranking? Vote using the buttons below.</p>
             <p className="nnd-readers-voteText">He was rated as number { item.id }. This is what you thought:</p>
           </div>
           <div className="nnd-btns">
             <a disabled={this.state.votingDisabled} onClick={(e) => { this.addVote(e, item.id, 'agree'); e.preventDefault() }}>Spot on<em>{ item.perc.agreePC }%</em></a>
             <a disabled={this.state.votingDisabled} onClick={(e) => { this.addVote(e, item.id, 'overrated'); e.preventDefault() }}>Lucky boy<em>{ item.perc.overratedPC }%</em></a>
             <a disabled={this.state.votingDisabled} onClick={(e) => { this.addVote(e, item.id, 'underrated'); e.preventDefault() }}>Bargain<em>{ item.perc.underratedPC }%</em></a>
             
           </div>
         </div>
        )
      }
    }) : ''

    const isBreached = this.state.breach
    // const isMobApp = this.state.isMobApp

    return (
      <div className="nnd-container">
        <div className="nnd-header">
          <img src={require('../assets/images/header.svg')} />
        </div>
        <div className="nnd-navigation-bg"></div>
        <div className="nnd-navigation">
            <div className="nnd-nav-btns">
              <a className="nnd-active-expert" onClick={(e) => { this.setClassName(e, 'expert'); e.preventDefault() }}>Official Top 100</a>

              {isBreached === true
                ? 
                <a onClick={(e) => { this.scroll2message(); e.preventDefault() }}>Readers' Top 100</a>
                : 
                <a onClick={(e) => { this.setClassName(e, 'people'); e.preventDefault() }}>Readers' Top 100</a>
              }

              
            </div>
        </div>
        <div name="nnd-expert" className="nnd-cont-main">
          {mylist}
        </div>

        {isBreached === true
          ? 
          <div id="nnd-breach-overlay" className="nnd-breach-overlay" ref={this.scrollDiv}>
            
              <div className="nnd-breach-message">
                <p className="nnd-bm1"><span>There's more to this story.</span></p>
                <p className="nnd-bm1"><span>Subscribe today to unlock the full Rich 100 list.</span></p>
                <p className="nnd-bm2">Only $1 a week for the first 12 weeks<br />(min cost $4)</p>
                <a className="nnd-breachLink" onClick={(e) => { this.goSubscribe(e) }}>Subscribe</a>
                <p className="nnd-bm3"><a onClick={(e) => { this.goLogin(e); e.preventDefault() }}>Log in</a> | T&Cs apply</p>
              </div>
            
          </div>
          : ''
        }
        
      </div>
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js